export const bannerPageValues = [
  {
    value: "home",
    label: "Homepage",
  },
  {
    value: "search-result-generic",
    label: "Search Result (Generic)",
  },
  {
    value: "listing-generic",
    label: "Listing (Generic)",
  },
  {
    value: "listing-detail-generic",
    label: "Listing Detail (Generic)",
  },
  {
    value: "blog",
    label: "Blog Library",
  },
  {
    value: "video-wall",
    label: "Video Wall",
  },
  {
    value: "terms-conditions",
    label: "Terms Conditions",
  },
  {
    value: "condition-guide",
    label: "Condition Guide",
  },
  {
    value: "about-us",
    label: "About Us",
  },
  {
    value: "size-guide",
    label: "Size Guide",
  },
  {
    value: "contact-us",
    label: "Contact Us",
  },
  {
    value: "privacy-policy",
    label: "Privacy Policy",
  },
  {
    value: "legal-detail",
    label: "Legal Detail",
  },
  {
    value: "team-profiles",
    label: "Team Profiles",
  },
  {
    value: "event-profiles",
    label: "Event Profiles",
  },
  {
    value: "player-profiles",
    label: "Player Profiles",
  },
];
